module.exports = __webpack_public_path__ + "img/ic_qrcode_facebook.e655216.webp";